/* eslint-disable no-unused-vars */

import React from 'react'
import styled from 'styled-components'
import Menu from '../../../components/Menu/Navbar'
import Header from '../../../components/Header/header'
import Logo from '../../../components/Logo/logo'
import Footer from '../../../components/Footer/footer'
import { ContainerGeneral, TituloGrande, ContainerTexto } from '../../RioGrande/styletexto'
import FxView from '../../../components/FxView/fxview'



import PDFEscuelaDePadel from '../../../components/Airbus/PDFAcademiaDePadel/academiadepadel'





const ContainerImagenes = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

const Imagen = styled.img`
  width: 90%;
  max-width: 900px;
  height: auto;
  margin: 40px;
`



const EscuelaDePadel = () => {
  return (
    <div>
      <Menu />
      <Header />
      <Logo />
      <FxView />

  

      <ContainerGeneral>
        <ContainerTexto>
          <TituloGrande>
            Información e inscripción Temporada 25 - 26{' '}
          </TituloGrande>

          <ContainerImagenes>
            <Imagen
              src={require('./Escuela de padel G.E AIRBUS.jpg')}
              alt="Escuela de padel G.E AIRBUS 24-25"
            />
          </ContainerImagenes>



           <PDFEscuelaDePadel/> 

        </ContainerTexto>
      </ContainerGeneral>

      <Footer />
      <></>
    </div>
  )
}

export default EscuelaDePadel








